// Live on/off switch for Boost. The owner flips it in Admin Console ("Boost lock");
// it is stored in settings/app -> { boostEnabled: boolean } and is the same for the
// website and the app. Missing flag = locked ("Coming soon").
import { useSyncExternalStore } from 'react'

let enabled = false
const subs = new Set<() => void>()

export function setBoostEnabledFlag(next: boolean) {
  if (enabled === next) return
  enabled = next
  subs.forEach((fn) => fn())
}

const subscribe = (fn: () => void) => { subs.add(fn); return () => { subs.delete(fn) } }

/** true when Boost is switched ON by the owner. */
export function useBoostEnabled(): boolean {
  return useSyncExternalStore(subscribe, () => enabled, () => false)
}
